import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&规格部分
 *
 */



/**
 * 规格查询：列表
 * @param {*} query
 */
export const productOne = (query) => {
  return request({
    url: `${prefix}/product`,
    method: 'get',
    params: query
  })
}

/**
 * 规格查询：列表
 * @param {*} query
 */
export const productPropertyList = (query) => {
  return request({
    url: `${prefix}/product/property/list`,
    method: 'get',
    params: query
  })
}

/**
 * 规格查询
 * @param {*} query
 */
export const productPropertyOne = (query) => {
  return request({
    url: `${prefix}/product/property`,
    method: 'get',
    params: query
  })
}

/**
 * 规格创建
 * @param {*} query
 */
export const productPropertyCreate = (query) => {
  return request({
    url: `${prefix}/product/property`,
    method: 'post',
    data: query
  })
}

/**
 * 规格修改
 * @param {*} query
 */
export const productPropertyUpdate = (query) => {
  return request({
    url: `${prefix}/product/property`,
    method: 'put',
    data: query
  })
}

/**
 * 规格删除
 * @param {*} query
 */
export const productPropertyDestroy = (query) => {
  return request({
    url: `${prefix}/product/property`,
    method: 'delete',
    data: query
  })
}

/**
 * 规格删除 真
 * @param {*} query
 */
export const productPropertyRemove = (query) => {
  return request({
    url: `${prefix}/product/property/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 规格值查询：列表
 * @param {*} query
 */
export const productPropertyValueList = (query) => {
  return request({
    url: `${prefix}/product/property/value/list`,
    method: 'get',
    params: query
  })
}

/**
 * 规格值查询
 * @param {*} query
 */
export const productPropertyValueOne = (query) => {
  return request({
    url: `${prefix}/product/property/value`,
    method: 'get',
    params: query
  })
}

/**
 * 规格值创建
 * @param {*} query
 */
export const productPropertyValueCreate = (query) => {
  return request({
    url: `${prefix}/product/property/value`,
    method: 'post',
    data: query
  })
}

/**
 * 规格值修改
 * @param {*} query
 */
export const productPropertyValueUpdate = (query) => {
  return request({
    url: `${prefix}/product/property/value`,
    method: 'put',
    data: query
  })
}

/**
 * 规格值删除
 * @param {*} query
 */
export const productPropertyValueDestroy = (query) => {
  return request({
    url: `${prefix}/product/property/value`,
    method: 'delete',
    data: query
  })
}

/**
 * 规格值删除 真
 * @param {*} query
 */
export const productPropertyValueRemove = (query) => {
  return request({
    url: `${prefix}/product/property/value/remove`,
    method: 'delete',
    data: query
  })
}


/**
 * 商品分类查询：列表
 * @param {*} query
 */
export const productCategoryList = (query) => {
  return request({
    url: `${prefix}/product/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 商品分类查询
 * @param {*} query
 */
export const productCategoryOne = (query) => {
  return request({
    url: `${prefix}/product/category`,
    method: 'get',
    params: query
  })
}

/**
 * 商品分类创建
 * @param {*} query
 */
export const productCategoryCreate = (query) => {
  return request({
    url: `${prefix}/product/category`,
    method: 'post',
    data: query
  })
}

/**
 * 商品分类修改
 * @param {*} query
 */
export const productCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/product/category`,
    method: 'put',
    data: query
  })
}

/**
 * 商品分类删除
 * @param {*} query
 */
export const productCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/product/category`,
    method: 'delete',
    data: query
  })
}

/**
 * 产品（产品评价查询列表）
 * @param {*} query
 */
export const appraiselist = (query) => {
  return request({
    url: `${prefix}/product/appraise/list`,
    method: 'get',
    params: query
  })
}


/**
 * 产品（产品评价创建）
 * @param {*} query
 */
export const productappraiseCreate = (query) => {
  return request({
    url: `${prefix}/product/appraise`,
    method: 'post',
    data: query
  })
}


/**
 * 产品（产品评价查询详情）
 * @param {*} query
 */
export const productappraiseOne = (query) => {
  return request({
    url: `${prefix}/product/appraise`,
    method: 'get',
    params: query
  })
}


/**
 * 产品（产品评价修改）
 * @param {*} query
 */
export const productappraiseUpdate = (query) => {
  return request({
    url: `${prefix}/product/appraise`,
    method: 'put',
    data: query
  })
}


/**
 * 产品（产品评价删除）
 * @param {*} query
 */
export const productappraiseDestroy = (query) => {
  return request({
    url: `${prefix}/product/appraise`,
    method: 'delete',
    data: query
  })
}


/**
 * 产品（产品评价批量删除）
 * @param {*} query
 */
 export const productappraiselistDestroy = (query) => {
  return request({
    url: `${prefix}/product/appraise/list`,
    method: 'delete',
    data: query
  })
}

